import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, colors, Text, VStack } from '@rtkwlf/fenrir-react';
import { faExclamationTriangle } from '@rtkwlf/pro-regular-svg-icons/faExclamationTriangle';
import { useTranslation } from 'react-i18next';

interface DataErrorProps {
  customErrorMessage?: string;
}

export const DataError: React.FC<DataErrorProps> = ({ customErrorMessage }) => {
  const { t } = useTranslation();

  return (
    <VStack alignItems="center">
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        size="3x"
        color={`rgb(${colors.accent.grey.default})`}
      />
      <Text textAlign="center" textColor="body">
        {customErrorMessage || t('error:dataErrorMessage')}
      </Text>
      <Text textAlign="center" textColor="body">
        {t('error:refreshMessage')}
      </Text>
      <Button
        onClick={() => {
          window.location.reload();
        }}
      >
        {t('error:globalError.refresh')}
      </Button>
    </VStack>
  );
};
